import styled from 'styled-components';

export const ClusteringContainer = styled.div`
    display: flex;
    flex-flow: column nowrap;
    height: 100%;
`;

export const ClusteringChartContainer = styled.div`
    flex-grow: 1;
    overflow: hidden;
`;

export const ClusteringControls = styled.div`
    display: flex;
    flex-flow: row nowrap;
    align-items: center;
    margin-bottom: 10px;
`;

export const ClusteringControl = styled.div`
    margin-right: 10px;
`;
